import React from 'react';

import styled from 'styled-components';

import EmailNotifications from './EmailNotifications/EmailNotifications';
import GeneralSettings from './GeneralSettings/GeneralSettings';
import SettingsHeader from './SettingsHeader';
import { useAppSelector } from '../../store/hook';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  justify-content: flex-start;
`;

const SettingsOverview = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const canViewAllSettings = Boolean(currentUser?.isSuperuser || currentUser?.feature_flags?.view_pricing_data);

  return (
    <Container>
      <SettingsHeader />
      {canViewAllSettings && <GeneralSettings />}
      <EmailNotifications />
    </Container>
  );
};

export default SettingsOverview;
